import { connect } from 'react-redux';
import { createSelector } from 'reselect';
// eslint-disable-next-line import/no-cycle
import { gotoNextStep } from '../steps/actions';

// eslint-disable-next-line import/no-cycle
import { sendLoginCode, confirmLoginCode, resetValidation, clearTimer, reset } from './actions';
import {
  selectMobileNumber,
  selectLoginCodeExpiry,
  selectMobileValidationResult,
  selectMobileLoginCodeSendingFailed,
  selectMobileVerificationMessage,
  selectCanResendLoginCode,
  selectMobileNumberFromInvitation,
} from '../../../selectors';
import MobileVerification from './Component';

const mapStateToProps = createSelector(
  selectMobileNumber,
  selectLoginCodeExpiry,
  selectMobileValidationResult,
  selectMobileLoginCodeSendingFailed,
  selectMobileVerificationMessage,
  selectCanResendLoginCode,
  selectMobileNumberFromInvitation,
  (
    mobileNumber,
    codeExpiry,
    validationResult,
    loginCodeSendingFailed,
    message,
    canResendLoginCode,
    mobileNumberFromInvitation,
  ) => ({
    mobileNumber,
    codeExpiry,
    validationResult,
    loginCodeSendingFailed,
    message,
    canResendLoginCode,
    mobileNumberFromInvitation,
  }),
);

function mapDispatchToProps(dispatch) {
  return {
    // eslint-disable-next-line no-unused-labels
    sendLoginCode: (mobileNumber, callback) => dispatch(sendLoginCode(mobileNumber, callback)),
    confirmLoginCode: (pin, loggedInUser, callback) =>
      dispatch(confirmLoginCode(pin, loggedInUser, callback)),
    resetValidation: () => dispatch(resetValidation()),
    continueToNextStep: () => dispatch(gotoNextStep()),
    clearTimer,
    reset: () => dispatch(reset()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileVerification);
